import { Grid, useEventCallback } from '@mui/material';
import { memo, useCallback } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import Italian from '../../../shared/italian';
import { ItalianForm } from 'shell/view-models/italian-form';
import ListAnsc from '../../../../../../../shared/list-ansc';
import { ItemVM } from 'shell/view-models/item';
import { ID_OTHER_RESIDENCE } from 'civil-status/constants/id-other-residence';

interface CitizenshipCit06Props {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  configuration?: string;
}

const CitizenshipCit06Component = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
}: CitizenshipCit06Props): React.ReactElement => {
  const handleListTypeResidence = useEventCallback((item?: ItemVM) => {
    onChange('typeResidence', item?.id);
  });

  const onChangeItalian = useCallback(
    (key, value) => {
      onChange('italian', {
        ...(values || {}).italian,
        [key]: value,
      });
    },
    [values, onChange]
  );

  const onChangesItalian = useCallback(
    (valuesNew) => {
      onChange('italian', {
        ...(values || {}).italian,
        ...valuesNew,
      });
    },
    [values, onChange]
  );

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <ListAnsc
          label="Tipo residenza"
          idDominio="57"
          value={values?.typeResidence || ''}
          onChange={handleListTypeResidence}
          disabled={disabled}
          error={Boolean(errors?.typeResidence) && touched?.typeResidence}
          required
        />
      </Grid>
      <Italian
        disabledComponent={disabled}
        values={values?.italian}
        onChange={onChangeItalian}
        onChanges={onChangesItalian}
        errors={errors?.italian as FormikErrors<ItalianForm>}
        touched={touched?.italian as unknown as FormikTouched<ItalianForm>}
        labelMunicipality="Comune nuova residenza"
        labelProvince="Provincia nuova residenza"
        required={values?.typeResidence === ID_OTHER_RESIDENCE}
      />
    </Grid>
  );
};

CitizenshipCit06Component.displayName = 'Form Citizenship Cit 06 Request component';

const CitizenshipCit06 = memo(CitizenshipCit06Component);

export default CitizenshipCit06;
